// extracted by mini-css-extract-plugin
module.exports = {"fieldsWrapper":"_15cZc-kdAIl0m3tSXxqZE9","row":"zTfdGlU5PTX6wfBD7MEwZ"};